module.exports = __webpack_public_path__ + "img/camera_mode_photo.da03ccba.svg";